import { Env } from '@stencil/core';

const URL_WIDGET = {
  PROD: 'https://widget.powerpay.pe',
  BETA: 'https://widget-bnpl-pe-bbva-beta.moprestamo.com',
  ALPHA: 'https://widget-bnpl-pe-bbva.moprestamo.com',
};

const URL_BASES = {
  PROD: 'https://components-bnpl-pe-bbva-production.moprestamo.com',
  BETA: 'https://components-bnpl-pe-bbva-beta.moprestamo.com',
  ALPHA: 'https://components-bnpl-pe-bbva.moprestamo.com',
};

const resources = {
  dev: {
    widget_url: URL_WIDGET.ALPHA,
    base_url: URL_BASES.ALPHA,
  },
  beta: {
    widget_url: URL_WIDGET.BETA,
    base_url: URL_BASES.BETA,
  },
  prod: {
    widget_url: URL_WIDGET.PROD,
    base_url: URL_BASES.PROD,
  },
};

const index = Env.environment ?? 'dev';

export const environment = resources[index];
